import React, { Component } from "react";
import { Row, Col, Spinner } from "react-bootstrap";
// import "./_offlineExams.scss";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import { withApollo } from "react-apollo";
import * as Cookies from 'es-cookie';
import SelectDropDown from '../selectdropdown/SelectDropDown';
import { scopeBranches, onBranchScopeChange } from "../../../utils/branchScope";

const GET_INTERNALS = gql`
  query getExamPhaseInternals(
    $exam_phase_id: Int!
    $class_id: Int!
    $stream_id: Int
    $academic_year_id: Int!
  ) {
    getExamPhaseInternals(
      exam_phase_id: $exam_phase_id
      class_id: $class_id
      stream_id: $stream_id
      academic_year_id: $academic_year_id
    ) {
          id
    class_id
    class_name
    stream_id
    stream_name
    year_id
    academic_year
    exam_phase_internals
    order_no
    exam_phase
    exam_phase_id
    academic_year_id
    exam_date
    }
  }
`;

const SAVE_INTERNALS = gql`
  mutation createExamPhaseConfiguration($data: ExamPhaseInternalInput) {
    createExamPhaseConfiguration(data: $data)
  }
`;

class ExamTypeConfig extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedClass: "",
      selectedStream: "",
      selectedExam: "",
      selectedAcademicYear: "",
      loader: 0,
      mainSubjects: [],
      errors: {},
      isSubmit: false,
      showConfig: false,
      searchQuery: "",
      currentPage: 1,
      pageSize: 10,
    };
  }


  componentDidMount() {
    const firstYear = this.props.getYears?.[0];
    if (firstYear) {
      this.setState({ selectedAcademicYear: String(firstYear.id) });
    }
    // Branch comes from the header (NavbarOne). The Class list is derived from it,
    // so a change can invalidate the current Class — drop it and hide the config.
    this.offBranchScope = onBranchScopeChange(() => {
      const stillValid = this.getFilteredClasses().some(
        (c) => String(c.id) === String(this.state.selectedClass)
      );
      if (!stillValid) this.setState({ selectedClass: "", selectedStream: "", showConfig: false, mainSubjects: [] });
      else this.forceUpdate();
    });
  }

  componentWillUnmount() {
    if (this.offBranchScope) this.offBranchScope();
  }


  mapApiToState = (data = []) => {
    return data.map((item) => ({
      id: item.id,  // ✅ needed for update
      title: item.exam_phase_internals || "",
      seq: item.order_no || "",
      maxMarks: item.max_marks || "",

      class_name: item.class_name,
      academic_year: item.academic_year,
      exam_phase: item.exam_phase,
      exam_date: item.exam_date,
      estatus: item.estatus ?? 1,
    }));
  };

  handleFetchData = async () => {
    const { selectedClass, selectedStream, selectedExam, selectedAcademicYear } = this.state;

    if (!selectedClass || !selectedExam || !selectedAcademicYear) {
      toast.error("Please select all filters");
      return;
    }

    this.setState(prev => ({
      ...prev,
      loader: 1,
    }));

    try {
      const res = await this.props.client.query({
        query: GET_INTERNALS,
        variables: {
          exam_phase_id: +selectedExam,
          class_id: +selectedClass,
          stream_id: selectedStream ? +selectedStream : null,
          academic_year_id: +selectedAcademicYear,
        },
        fetchPolicy: "no-cache",
      });

      const apiData = res?.data?.getExamPhaseInternals || [];

      this.setState({
        mainSubjects: this.mapApiToState(apiData),
        showConfig: true,
        searchQuery: "",
        currentPage: 1,
      });

      if (apiData.length === 0) {
        this.handleAddRow();
      }

    } catch (err) {
      console.error(err);
    } finally {
      this.setState(prev => ({
        ...prev,
        loader: 0,
      }))
    }
  };

  // Classes offered by any branch the header currently has in scope. This used to
  // be "classes of the one branch picked in the local Branch dropdown".
  getFilteredClasses = () => {
    const { getBranchesQuery, getClasses } = this.props;
    const branches = scopeBranches(getBranchesQuery || []);
    const classIds = [...new Set(branches.flatMap((b) => (b.sections || []).map((s) => s.class_id)))];
    return (getClasses || []).filter((c) => classIds.includes(c.id));
  };

  getStreamOptions = () => {
    const { getStreams } = this.props;
    const { selectedClass } = this.state;
    if (!getStreams?.length || !selectedClass) return [];
    const classId = Number(selectedClass);
    return (getStreams || [])
      .filter((st) => {
        const classCsv = String(st.classes || "").split(",").map((v) => Number(v.trim())).filter(Boolean);
        return classCsv.includes(classId);
      })
      .map((st) => ({ value: st.id, label: st.stream, id: st.id }));
  };

  // Dropdown handler
  handleDropdown = (field, e) => {
    const value = e.target.value;
    const extraReset = field === "selectedClass" ? { selectedStream: "" } : {};

    this.setState(
      {
        [field]: value,
        showConfig: false,
        mainSubjects: [],
        searchQuery: "",
        currentPage: 1,
        ...extraReset,
      },
      () => {
        const { selectedClass, selectedExam, selectedAcademicYear } = this.state;
        if (selectedClass && selectedExam && selectedAcademicYear) {
          this.handleFetchData();
        }
      }
    );
  };

  handleSelectChange = (name, value) => {
    const extraReset = name === "selectedClass" ? { selectedStream: "" } : {};
    this.setState(
      {
        [name]: String(value),
        showConfig: false,
        mainSubjects: [],
        searchQuery: "",
        currentPage: 1,
        ...extraReset,
      },
      () => {
        const { selectedClass, selectedExam, selectedAcademicYear } = this.state;
        if (selectedClass && selectedExam && selectedAcademicYear) {
          this.handleFetchData();
        }
      }
    );
  };

  // Add new row
  handleAddRow = () => {
    const { selectedClass, selectedAcademicYear } = this.state;
    console.log("calling............");

    // get display values from props
    const classObj = this.props.getClasses?.find(
      (c) => +c.id === +selectedClass
    );

    const yearObj = this.props.getYears?.find(
      (y) => +y.id === +selectedAcademicYear
    );

    this.setState((prev) => {
      const nextSubjects = [
        ...prev.mainSubjects,
        {
          id: 0, // ✅ for insert
          title: "",
          seq: prev.mainSubjects.filter((s) => s.estatus !== 0).length + 1,
          maxMarks: "",

          // ✅ attach display fields
          class_name: classObj?.class || "",
          academic_year: yearObj?.academic_year || "",
          estatus: 1,
        },
      ];

      // Switch to the last page of the new list
      const activeCount = nextSubjects.filter((s) => s.estatus !== 0).length;
      const pageSizeVal = prev.pageSize;
      let targetPage = prev.currentPage;
      if (pageSizeVal !== "All") {
        targetPage = Math.ceil(activeCount / parseInt(pageSizeVal, 10)) || 1;
      }

      return {
        mainSubjects: nextSubjects,
        currentPage: targetPage,
      };
    });
  };

  // Handle input change
  handleInputChange = (index, field, value) => {
    this.setState((prev) => {
      const updated = [...prev.mainSubjects];
      updated[index][field] = value;
      return { mainSubjects: updated };
    });
  };

  // Remove row
  handleRemoveRow = (index) => {
    this.setState((prev) => {
      const updated = [...prev.mainSubjects];
      const row = updated[index];

      if (row.id && row.id > 0) {
        // ✅ Existing record → mark as inactive
        updated[index] = {
          ...row,
          estatus: 0,
        };
      } else {
        // ✅ New row → remove completely
        updated.splice(index, 1);
      }

      return { mainSubjects: updated };
    }, () => {
      toast.info("Row removed. Click Save Configuration to apply changes.");
    });
  };

  validateRows = () => {
    const errors = {};
    let errorMessages = [];

    this.state.mainSubjects.forEach((item, index) => {
      if (item.estatus === 0) return;

      const rowError = {};

      if (!item.title || !item.title.trim()) {
        rowError.title = "Title is required";
        errorMessages.push(`Row ${index + 1}: Title is required`);
      }

      if (!item.seq) {
        rowError.seq = "Sequence is required";
        errorMessages.push(`Row ${index + 1}: Sequence is required`);
      } else if (isNaN(item.seq)) {
        rowError.seq = "Must be a number";
        errorMessages.push(`Row ${index + 1}: Sequence must be a number`);
      }

      if (Object.keys(rowError).length > 0) {
        errors[index] = rowError;
      }
    });

    this.setState({ errors });

    // 🔥 SHOW TOAST ERRORS
    if (errorMessages.length > 0) {
      toast.error(errorMessages[0]); // show first error

      // Auto-navigate to the page of the first error
      const firstErrorIndex = Object.keys(errors)[0]; // original index
      if (firstErrorIndex !== undefined) {
        const { searchQuery, pageSize, mainSubjects } = this.state;

        const activeMappedSubjects = mainSubjects
          .map((item, idx) => ({ item, idx }))
          .filter(({ item }) => item.estatus !== 0);

        const query = searchQuery.trim().toLowerCase();
        const filteredMappedSubjects = activeMappedSubjects.filter(({ item }) => {
          if (!query) return true;
          const titleMatch = (item.title || "").toLowerCase().includes(query);
          const seqMatch = String(item.seq || "").toLowerCase().includes(query);
          const classMatch = (item.class_name || "").toLowerCase().includes(query);
          const yearMatch = (item.academic_year || "").toLowerCase().includes(query);
          return titleMatch || seqMatch || classMatch || yearMatch;
        });

        const errorPos = filteredMappedSubjects.findIndex(({ idx }) => String(idx) === String(firstErrorIndex));
        if (errorPos !== -1 && pageSize !== "All") {
          const errorPage = Math.floor(errorPos / parseInt(pageSize, 10)) + 1;
          this.setState({ currentPage: errorPage });
        }
      }
    }

    return Object.keys(errors).length === 0;
  };


  handleSave = async () => {
    const isValid = this.validateRows();
    if (!isValid) return;

    const { selectedClass, selectedStream, selectedExam, selectedAcademicYear } = this.state;

    const internals = this.state.mainSubjects.map((item) => ({
      id: item.id || undefined,
      exam_phase_internals: item.title,
      order_no: +item.seq,
      // max_marks: +item.maxMarks,
      estatus: item.estatus ?? 1,
    }));

    this.setState(prev => ({
      ...prev,
      isSubmit: true,
    }));

    try {
      await this.props.client.mutate({
        mutation: SAVE_INTERNALS,
        variables: {
          data: {
            exam_phase_id: +selectedExam,
            class_id: +selectedClass,
            stream_id: selectedStream ? +selectedStream : null,
            academic_year_id: +selectedAcademicYear,
            updated_by: parseInt(Cookies.get("id")),
            internals,
          },
        },
      });

      const firstYear = this.props.getYears?.[0];
      this.setState({
        selectedClass: "",
        selectedStream: "",
        selectedExam: "",
        selectedAcademicYear: firstYear ? String(firstYear.id) : "",
        loader: 0,
        mainSubjects: [],
        errors: {},
        isSubmit: false,
        showConfig: false,
        searchQuery: "",
        currentPage: 1,
      });

      toast.success("Exam Type Configuration Created successfully");

    } catch (err) {
      console.error(err);
      alert("Save Failed ❌");
    } finally {
      this.setState(prev => ({
        ...prev,
        isSubmit: false,
      }));
    }
  };

  render() {
    const { searchQuery, currentPage, pageSize, mainSubjects } = this.state;
    console.log("test", mainSubjects);

    const styles = {
      page: {
        // background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)",
        minHeight: "100vh",
        padding: "28px 24px",
      },
      statCard: {
        background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
        borderRadius: 16,
        padding: "20px 24px",
        color: "#fff",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        boxShadow: "0 4px 20px rgba(99,102,241,0.3)",
        marginBottom: 24,
      },
      statLabel: { fontSize: 13, opacity: 0.85, marginBottom: 4, fontWeight: 500 },
      statValue: { fontSize: 36, fontWeight: 800, lineHeight: 1 },
      statIcon: {
        fontSize: 36,
        background: "rgba(255,255,255,0.2)",
        borderRadius: 12,
        width: 60,
        height: 60,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
      card: {
        background: "#fff",
        borderRadius: 20,
        boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
        border: "none",
        marginBottom: 24,
      },
      cardHeader: {
        border: "1px solid #e5e7eb",
        background: "rgba(250, 251, 255, 1)",
        color: "#000",
        padding: "18px 24px",
        display: "flex",
        alignItems: "center",
        gap: 10,
      },
      cardHeaderTitle: {
        color: "#000",
        fontWeight: 700,
        fontSize: 17,
        margin: 0,
      },
      cardHeaderIcon: {
        width: 32,
        height: 32,
        borderRadius: 8,
        background: "rgb(224,231,255)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#6366f1",
        fontSize: 14,
      },
      cardBody: { padding: "22px 24px" },
      label: { fontSize: 12, fontWeight: 600, color: "#6b7280", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.5px" },
      input: {
        borderRadius: 10,
        border: "1.5px solid #e5e7eb",
        padding: "9px 14px",
        fontSize: 14,
        color: "#1f2937",
        background: "#f9fafb",
        transition: "border-color 0.2s",
        width: "100%",
      },
      addBtn: {
        background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
        border: "none",
        borderRadius: 10,
        padding: "9px 20px",
        fontWeight: 700,
        fontSize: 14,
        color: "#fff",
        width: "100%",
        boxShadow: "0 4px 12px rgba(16,185,129,0.3)",
        cursor: "pointer",
      },
      tableWrapper: {
        overflowX: "auto",
      },
      thead: {},
      th: {
        color: "#000",
        padding: "16px",
        fontSize: "14px",
        fontWeight: "600",
        whiteSpace: "nowrap",
        border: "1px solid #e5e7eb",
        background: "rgba(250, 251, 255, 1)",
      },
      td: {
        padding: "13px 16px",
        verticalAlign: "middle",
        fontSize: 14,
        color: "#374151",
        borderBottom: "1px solid #f3f4f6",
        border: "none",
      },
      idBadge: {
        background: "linear-gradient(135deg, #dbeafe, #ede9fe)",
        color: "#4f46e5",
        borderRadius: 20,
        padding: "3px 12px",
        fontWeight: 700,
        fontSize: 12,
        display: "inline-block",
        border: "1px solid #c7d2fe",
      },
      phaseName: { fontWeight: 600, color: "#1f2937" },
      standardPill: {
        background: "#f0fdf4",
        color: "#15803d",
        borderRadius: 20,
        padding: "3px 12px",
        fontWeight: 600,
        fontSize: 12,
        display: "inline-block",
        border: "1px solid #bbf7d0",
      },
      yearPill: {
        background: "#fff7ed",
        color: "#c2410c",
        borderRadius: 20,
        padding: "3px 12px",
        fontWeight: 600,
        fontSize: 12,
        display: "inline-block",
        border: "1px solid #fed7aa",
      },
      editBtn: {
        background: "linear-gradient(135deg, #f59e0b, #d97706)",
        border: "none",
        borderRadius: 8,
        padding: "5px 14px",
        fontWeight: 600,
        fontSize: 12,
        color: "#fff",
        cursor: "pointer",
        boxShadow: "0 2px 8px rgba(245,158,11,0.3)",
      },
      saveBtn: {
        background: "linear-gradient(135deg, #10b981, #059669)",
        border: "none",
        borderRadius: 8,
        padding: "5px 14px",
        fontWeight: 600,
        fontSize: 12,
        color: "#fff",
        cursor: "pointer",
        marginRight: 6,
        boxShadow: "0 2px 8px rgba(16,185,129,0.3)",
      },
      cancelBtn: {
        background: "#f3f4f6",
        border: "1px solid #e5e7eb",
        borderRadius: 8,
        padding: "5px 14px",
        fontWeight: 600,
        fontSize: 12,
        color: "#6b7280",
        cursor: "pointer",
      },
      deleteBtn: {
        background: "linear-gradient(135deg, #ef4444, #dc2626)",
        border: "none",
        borderRadius: 8,
        padding: "5px 14px",
        fontWeight: 600,
        fontSize: 12,
        color: "#fff",
        cursor: "pointer",
        boxShadow: "0 2px 8px rgba(239,68,68,0.3)",
      },
      emptyState: {
        textAlign: "center",
        padding: "48px 20px",
        color: "#9ca3af",
      },
      emptyIcon: { fontSize: 48, marginBottom: 12, display: "block" },
      emptyText: { fontWeight: 600, fontSize: 15, color: "#6b7280", margin: 0 },
      emptySubText: { fontSize: 13, color: "#9ca3af", marginTop: 4 },
      filterRow: {
        display: "flex",
        gap: 12,
        alignItems: "flex-end",
        flexWrap: "wrap",
      },
      filterItem: { flex: "1 1 180px", minWidth: 160 },
      sectionDivider: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: 16,
        flexWrap: "wrap",
        gap: 12,
      },
      countChip: {
        background: "linear-gradient(135deg, #ede9fe, #dbeafe)",
        color: "#4f46e5",
        borderRadius: 20,
        padding: "4px 14px",
        fontWeight: 700,
        fontSize: 13,
        border: "1px solid #c7d2fe",
      },
      searchContainer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 16,
        padding: "16px 20px",
        borderBottom: "1px solid #e5e7eb",
        background: "#fff",
      },
      searchWrapper: {
        position: "relative",
        display: "flex",
        alignItems: "center",
        minWidth: 260,
      },
      searchInput: {
        padding: "8px 12px 8px 36px",
        fontSize: 14,
        borderRadius: 8,
        border: "1.5px solid #e5e7eb",
        width: "100%",
        outline: "none",
        transition: "all 0.2s ease",
      },
      searchIcon: {
        position: "absolute",
        left: 12,
        color: "#9ca3af",
        fontSize: 14,
      },
      clearSearchBtn: {
        position: "absolute",
        right: 12,
        background: "none",
        border: "none",
        color: "#9ca3af",
        cursor: "pointer",
        padding: 0,
        fontSize: 14,
      },
      pageSizeWrapper: {
        display: "flex",
        alignItems: "center",
        gap: 8,
        fontSize: 14,
        color: "#4b5563",
      },
      pageSizeSelect: {
        padding: "6px 12px",
        borderRadius: 8,
        border: "1.5px solid #c084fc",
        background: "#f3e8ff",
        color: "#6b21a8",
        outline: "none",
        cursor: "pointer",
        fontWeight: 600,
        fontSize: 13,
      },
      paginationContainer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 16,
        padding: "16px 20px",
        borderTop: "1px solid #e5e7eb",
        background: "#fff",
      },
      paginationInfo: {
        fontSize: 14,
        color: "#4b5563",
      },
      paginationButtons: {
        display: "flex",
        alignItems: "center",
        gap: 6,
      },
      pageBtn: {
        padding: "6px 12px",
        fontSize: 13,
        fontWeight: 600,
        borderRadius: 8,
        border: "1.5px solid #e5e7eb",
        background: "#fff",
        color: "#4b5563",
        cursor: "pointer",
        transition: "all 0.2s ease",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: 36,
        height: 36,
      },
      pageBtnActive: {
        background: "#dee2e6",
        color: "#1f2937",
        borderColor: "#dee2e6",
      },
      pageBtnDisabled: {
        background: "#f3f4f6",
        color: "#d1d5db",
        borderColor: "#e5e7eb",
        cursor: "not-allowed",
      },
    };

    // Filter, search and pagination calculations
    const activeMappedSubjects = mainSubjects
      .map((item, idx) => ({ item, idx }))
      .filter(({ item }) => item.estatus !== 0);

    const query = searchQuery.trim().toLowerCase();
    const filteredMappedSubjects = activeMappedSubjects.filter(({ item }) => {
      if (!query) return true;
      const titleMatch = (item.title || "").toLowerCase().includes(query);
      const seqMatch = String(item.seq || "").toLowerCase().includes(query);
      const classMatch = (item.class_name || "").toLowerCase().includes(query);
      const yearMatch = (item.academic_year || "").toLowerCase().includes(query);
      return titleMatch || seqMatch || classMatch || yearMatch;
    });

    const pageSizeNum = pageSize === "All" ? filteredMappedSubjects.length : parseInt(pageSize, 10);
    const totalPages = pageSize === "All" ? 1 : Math.ceil(filteredMappedSubjects.length / pageSizeNum) || 1;

    let activePage = currentPage;
    if (activePage > totalPages) {
      activePage = totalPages;
    }
    if (activePage < 1) {
      activePage = 1;
    }

    const startIndex = pageSize === "All" ? 0 : (activePage - 1) * pageSizeNum;
    const paginatedMappedSubjects = filteredMappedSubjects.slice(startIndex, startIndex + pageSizeNum);

    const searchToolbar = (
      <div style={{ ...styles.searchContainer, justifyContent: "flex-end" }}>
        <div style={styles.searchWrapper}>
          <i className="fa fa-search" style={styles.searchIcon} />
          <input
            type="text"
            style={styles.searchInput}
            placeholder="Search Class, Year, Title or Seq..."
            value={searchQuery}
            onChange={(e) => {
              this.setState({
                searchQuery: e.target.value,
                currentPage: 1,
              });
            }}
          />
          {searchQuery && (
            <button
              type="button"
              style={styles.clearSearchBtn}
              onClick={() => this.setState({ searchQuery: "", currentPage: 1 })}
            >
              <i className="fa fa-times" />
            </button>
          )}
        </div>
      </div>
    );

    const showingStart = filteredMappedSubjects.length === 0 ? 0 : startIndex + 1;
    const showingEnd = Math.min(startIndex + pageSizeNum, filteredMappedSubjects.length);
    const showingText = `Showing ${showingStart} to ${showingEnd} of ${filteredMappedSubjects.length} Results`;

    const pageNumbers = [];
    const maxVisibleButtons = 5;
    let startPage = Math.max(1, activePage - Math.floor(maxVisibleButtons / 2));
    let endPage = Math.min(totalPages, startPage + maxVisibleButtons - 1);
    if (endPage - startPage + 1 < maxVisibleButtons) {
      startPage = Math.max(1, endPage - maxVisibleButtons + 1);
    }
    for (let i = startPage; i <= endPage; i++) {
      if (i >= 1 && i <= totalPages) {
        pageNumbers.push(i);
      }
    }

    const paginationFooter = (
      <div style={styles.paginationContainer}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <select
            style={styles.pageSizeSelect}
            value={pageSize}
            onChange={(e) => {
              const val = e.target.value;
              this.setState({
                pageSize: val === "All" ? "All" : parseInt(val, 10),
                currentPage: 1,
              });
            }}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value="All">All</option>
          </select>
          <div style={styles.paginationInfo}>{showingText}</div>
        </div>
        <div style={styles.paginationButtons}>
          <button
            type="button"
            style={{
              ...styles.pageBtn,
              ...(activePage === 1 ? styles.pageBtnDisabled : {}),
            }}
            disabled={activePage === 1}
            onClick={() => this.setState({ currentPage: activePage - 1 })}
          >
            <i className="fa fa-chevron-left" style={{ fontSize: 11 }} />
          </button>

          {startPage > 1 && (
            <>
              <button
                type="button"
                style={{
                  ...styles.pageBtn,
                  ...(activePage === 1 ? styles.pageBtnActive : {}),
                }}
                onClick={() => this.setState({ currentPage: 1 })}
              >
                1
              </button>
              {startPage > 2 && <span style={{ color: "#9ca3af", padding: "0 4px" }}>...</span>}
            </>
          )}

          {pageNumbers.map((page) => (
            <button
              key={page}
              type="button"
              style={{
                ...styles.pageBtn,
                ...(activePage === page ? styles.pageBtnActive : {}),
              }}
              onClick={() => this.setState({ currentPage: page })}
            >
              {page}
            </button>
          ))}

          {endPage < totalPages && (
            <>
              {endPage < totalPages - 1 && <span style={{ color: "#9ca3af", padding: "0 4px" }}>...</span>}
              <button
                type="button"
                style={{
                  ...styles.pageBtn,
                  ...(activePage === totalPages ? styles.pageBtnActive : {}),
                }}
                onClick={() => this.setState({ currentPage: totalPages })}
              >
                {totalPages}
              </button>
            </>
          )}

          <button
            type="button"
            style={{
              ...styles.pageBtn,
              ...(activePage === totalPages ? styles.pageBtnDisabled : {}),
            }}
            disabled={activePage === totalPages}
            onClick={() => this.setState({ currentPage: activePage + 1 })}
          >
            <i className="fa fa-chevron-right" style={{ fontSize: 11 }} />
          </button>
        </div>
      </div>
    );

    return (
      <div style={styles.page}>
        {/* Top Section */}
        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <div style={styles.cardHeaderIcon}>
              <i className="fas fa-cog" />
            </div>
            <h5 style={styles.cardHeaderTitle}>Exam Type Configuration</h5>
          </div>

          <div style={styles.cardBody}>
            <Row className="g-3">
              {/* Academic Year */}
              <Col xs={12} sm={6} md={3}>
                <div style={styles.label}>Academic Year</div>
                <SelectDropDown
                  name="selectedAcademicYear"
                  placeholderName="Select Academic Year"
                  options={(this.props.getYears || []).map((year) => ({ value: year.id, label: year.academic_year, id: year.id }))}
                  stateData={(this.props.getYears || []).map((year) => ({ value: year.id, label: year.academic_year, id: year.id })).find((opt) => String(opt.value) === String(this.state.selectedAcademicYear)) || null}
                  handleChange={this.handleSelectChange}
                  isClearable={false}
                />
              </Col>

              {/* No Branch filter — the header's branch selection scopes this page. */}

              {/* Class */}
              <Col xs={12} sm={6} md={3}>
                <div style={styles.label}>Class</div>
                <SelectDropDown
                  name="selectedClass"
                  placeholderName="Select Class"
                  options={this.getFilteredClasses().map((cls) => ({ value: cls.id, label: cls.class, id: cls.id }))}
                  stateData={this.getFilteredClasses().map((cls) => ({ value: cls.id, label: cls.class, id: cls.id })).find((opt) => String(opt.value) === String(this.state.selectedClass)) || null}
                  handleChange={this.handleSelectChange}
                  isClearable={false}
                />
              </Col>

              {/* Stream */}
              {this.getStreamOptions().length > 0 && (
                <Col xs={12} sm={6} md={3}>
                  <div style={styles.label}>Stream</div>
                  <SelectDropDown
                    name="selectedStream"
                    placeholderName="Select Stream"
                    options={this.getStreamOptions()}
                    stateData={this.getStreamOptions().find((opt) => String(opt.value) === String(this.state.selectedStream)) || null}
                    handleChange={this.handleSelectChange}
                    isClearable={false}
                  />
                </Col>
              )}

              {/* Exam Phase */}
              <Col xs={12} sm={6} md={3}>
                <div style={styles.label}>Exam Phase</div>
                <SelectDropDown
                  name="selectedExam"
                  placeholderName="Select Exam Phase"
                  options={(this.props.getExamPhase || []).filter((item) => +item.academic_year_id === +this.state.selectedAcademicYear).map((item) => ({ value: item.id, label: `${item.exam_phase} - ${item.exam_standard_name}`, id: item.id }))}
                  stateData={(this.props.getExamPhase || []).filter((item) => +item.academic_year_id === +this.state.selectedAcademicYear).map((item) => ({ value: item.id, label: `${item.exam_phase} - ${item.exam_standard_name}`, id: item.id })).find((opt) => String(opt.value) === String(this.state.selectedExam)) || null}
                  handleChange={this.handleSelectChange}
                  isClearable={false}
                />
              </Col>

            </Row>
          </div>
        </div>

        {/* Loader */}
        {this.state.loader === 1 && (
          <div className="py-4">
            <style>
              {`
                      @keyframes shimmerLoading {
                          0% { background-position: -1000px 0; }
                          100% { background-position: 1000px 0; }
                      }
                      .shimmer-line {
                          height: 20px;
                          margin-bottom: 15px;
                          background: #f6f7f8;
                          background-image: linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%);
                          background-repeat: no-repeat;
                          background-size: 1000px 100%;
                          animation: shimmerLoading 1.5s infinite linear forwards;
                          border-radius: 4px;
                      }
                      .shimmer-header { height: 40px; margin-bottom: 24px; border-radius: 8px; }
                  `}
            </style>
            <div className="shimmer-line shimmer-header" style={{ width: '100%' }}></div>
            <div className="shimmer-line" style={{ width: '100%' }}></div>
            <div className="shimmer-line" style={{ width: '100%' }}></div>
            <div className="shimmer-line" style={{ width: '100%' }}></div>
            <div className="shimmer-line" style={{ width: '100%' }}></div>
            <div className="shimmer-line" style={{ width: '80%' }}></div>
          </div>
        )}

        {/* Empty State */}
        {/* {!this.state.loader && !this.state.showConfig && (
          <div style={styles.card} className="mt-4">
            <div style={styles.cardHeader}>
              <div style={styles.cardHeaderDot}></div>
              <h5 style={styles.cardHeaderTitle}>Exam Phase Internals</h5>
        {/* Table Section */}
        {!this.state.loader && this.state.showConfig && (
          <div style={styles.card}>
            <div style={styles.cardHeader}>
              <div style={styles.cardHeaderIcon}>
                <i className="fas fa-list-alt" />
              </div>
              <h5 style={styles.cardHeaderTitle}>
                Exam Phase Internals
              </h5>

              <div style={{ marginLeft: "auto" }}>
                <button style={styles.editBtn} onClick={this.handleAddRow}>
                  + Add Row
                </button>
              </div>
            </div>

            <div style={styles.cardBody}>
              <div style={{ border: "1px solid #e5e7eb", borderRadius: 12, overflow: "hidden" }}>
                {searchToolbar}
                <div style={styles.tableWrapper}>
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead style={styles.thead}>
                      <tr>
                        {["Class", "Year", "Title", "Seq", ...(activeMappedSubjects.length > 1 ? ["Action"] : [])].map(
                          (h) => (
                            <th key={h} style={styles.th}>{h}</th>
                          )
                        )}
                      </tr>
                    </thead>

                    <tbody>
                      {paginatedMappedSubjects.length === 0 ? (
                        <tr>
                          <td colSpan="5" style={{ textAlign: "center", padding: "48px 20px", color: "#9ca3af" }}>
                            <span role="img" aria-label="search" style={{ fontSize: 24, marginBottom: 8, display: "block" }}>🔍</span>
                            <p style={{ fontWeight: 600, fontSize: 14, color: "#6b7280", margin: 0 }}>No configuration matches your search</p>
                          </td>
                        </tr>
                      ) : (
                        paginatedMappedSubjects.map(({ item, idx }) => {
                          const error = this.state.errors[idx] || {};

                          return (
                            <tr key={item.id ? `row-${item.id}` : `new-${idx}`}>
                              <td style={styles.td}>{item.class_name}</td>
                              <td style={styles.td}>{item.academic_year}</td>

                              <td style={styles.td}>
                                <input
                                  style={styles.input}
                                  value={item.title}
                                  placeholder="Enter internal exam title"
                                  onChange={(e) =>
                                    this.handleInputChange(idx, "title", e.target.value)
                                  }
                                />
                                {error.title && (
                                  <div style={{ color: "#dc2626", fontSize: 12, marginTop: 4 }}>
                                    {error.title}
                                  </div>
                                )}
                              </td>

                              <td style={styles.td}>
                                {(() => {
                                  const seqOptions = Array.from({ length: activeMappedSubjects.length }, (_, idxSub) => idxSub + 1)
                                    .filter(n => {
                                      const usedSeqs = new Set(
                                        mainSubjects
                                          .filter((s, idxSub2) => idxSub2 !== idx && s.estatus !== 0)
                                          .map(s => +s.seq)
                                      );
                                      return !usedSeqs.has(n) || +item.seq === n;
                                    })
                                    .map(n => ({ value: n, label: String(n), id: n }));
                                  return (
                                    <SelectDropDown
                                      name="seq"
                                      placeholderName="Select Seq"
                                      options={seqOptions}
                                      stateData={seqOptions.find((opt) => String(opt.value) === String(item.seq)) || null}
                                      handleChange={(name, value) => this.handleInputChange(idx, "seq", value)}
                                      isClearable={false}
                                    />
                                  );
                                })()}
                                {error.seq && (
                                  <div style={{ color: "#dc2626", fontSize: 12, marginTop: 4 }}>
                                    {error.seq}
                                  </div>
                                )}
                              </td>

                              <td style={styles.td}>
                                {
                                  activeMappedSubjects.length > 1 && (
                                    <button
                                      type="button"
                                      style={styles.deleteBtn}
                                      onClick={() => this.handleRemoveRow(idx)}
                                      title="Remove this internal exam type"
                                    >
                                      Delete
                                    </button>
                                  )
                                }
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
                {paginationFooter}
              </div>

              {/* Save */}
              <Row className="justify-content-end" style={{ marginTop: 12 }}>
                <Col xs={12} sm={4} md={3}>
                  <button
                    style={{
                      ...(this.state.isSubmit ? styles.cancelBtn : styles.addBtn),
                      width: "100%"
                    }}
                    onClick={this.handleSave}
                    disabled={this.state.isSubmit}
                  >
                    {this.state.isSubmit ? "Saving..." : "Save Configuration"}
                  </button>
                </Col>
              </Row>
            </div>
          </div>
        )}

      </div>
    );
  }
}
export default withRouter(withApollo(compose(
  graphql(SAVE_INTERNALS, {
    name: "createExamPhaseConfiguration",
  }),
)(ExamTypeConfig),
));
